import { DialogTitle, Typography, withStyles } from "@material-ui/core";

export const BlueTitle = withStyles((theme) => ({
  headerTitle: {
    color: theme.palette.lightBlue,
  },
}))(({ classes: { headerTitle }, ...props }) => (
  <Typography
    variant="h2"
    color="textSecondary"
    className={headerTitle}
    {...props}
  />
));

export const ModalTitle = withStyles((theme) => ({
  dialogTitle: {
    textAlign: "center",
    color: '#4680FF',
    paddingBottom: theme.spacing(2),
    borderBottom: "2px solid",
    borderBottomColor: theme.palette.normalTextfield,
  },
}))(({ classes: { dialogTitle }, ...props }) => (
  <DialogTitle>
    <Typography
      variant="h2"
      color="textSecondary"
      className={dialogTitle}
      {...props}
    />
  </DialogTitle>
));
